import React, { Component } from "react"

import { instanceOf } from "prop-types"
import { withCookies, Cookies } from "react-cookie"
import * as cookieNames from "../constants/Cookies"

import * as endpoint from "../constants/Endpoints"
import LoginLink from "./common/loginLink"

import { UserProfile } from "../../hooks/userProfile"

class LoginState extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  }

  render() {
    const { config } = this.props
    const textKeys = config && config.textKeys ? config.textKeys : {}
    const idpToken = this.props.cookies.get(cookieNames.IDP_TOKEN_LOGIN) === "True"
    return (
      <UserProfile>
        {(profile) => {
          if (profile !== null && profile.ContactDetails) {
            // if(profile.ContactDetails.FirstName || profile.ContactDetails.LastName) {
            //   return (
            //     <a className={this.props.linkClassName || (!this.props.isShop && "button button--nav")} href={textKeys.myAdvantageLink}>
            //       <span className="text name">{profile.ContactDetails.FirstName} {profile.ContactDetails.LastName}</span>
            //     </a>
            //   )
            // } else {
            // return (
            //   <a className={this.props.linkClassName || (!this.props.isShop && "button button--nav")} href={textKeys.myAdvantageLink}>
            //     <span className="text name">{profile.EmailAddress}</span>
            //   </a>
            // )
            // }
            return (
              <a className={this.props.linkClassName || (!this.props.isShop && "button button--nav")} href={textKeys.myAdvantageLink}>
                <span className="text name">{textKeys.cphProfileLabel}</span>
              </a>
            )
          } else if (idpToken) {
            return (
              <LoginLink
                loginurl={endpoint.ACCOUNT_LOGIN(config && config.hosts, config && config.language)}
                linkClassName={this.props.linkClassName || "button button--nav"}
                spanClassName={"text name"}
                linkText={textKeys.myAdvantageLabel}
                isShop={this.props.isShop}
                trackingHandler={this.props.trackingHandler}
              />
            )
          } else {
            return (
              <LoginLink
                loginurl={endpoint.ACCOUNT_LOGIN(config && config.hosts, config && config.language)}
                linkClassName={this.props.linkClassName || "button button--nav"}
                spanClassName={"text"}
                linkText={textKeys.loginLabel}
                isShop={this.props.isShop}
                trackingHandler={this.props.trackingHandler}
              />
            )
          }
        }}
      </UserProfile>
    )
  }
}

export default withCookies(LoginState)
